import { useState } from 'react'
import { useHistory } from 'react-router'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import { IService } from '../../../types/services'
import { ITemplate } from '../../../types/templates'
import { SERVICE_STATUS } from '../../../types/services'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Alert, { ActionsOptType } from '../../../components/Alert'
import DialogContentText from '@material-ui/core/DialogContentText'

// Define IDialogEnd interface
interface IDialogEnd {
  open: boolean
  template: ITemplate
  setOpen: (newState: boolean) => void
  currentService?: IService
}
  
/**
 * Custom `EndServiceDialog` component declaration.
 * This component is used to end the creation of the document with a custom message and redirect the user
 * @param {boolean} open
 * @param {Object} template
 * @param {Funtion} setOpen
 * @param {Object} currentService
 * @return EndServiceDialog
*/
const EndServiceDialog = ({
    open,
    template,
    setOpen,
    currentService
  }: IDialogEnd): JSX.Element => {
  const history = useHistory()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * This method is used to close dialog
   * @Return {void}
  */
  const handleClose = () => {
    setOpen(false)
  }

  /**
   * This is used to redirect the app.
  */
  const goDocuments = async () => {
    history.push('/documents') 
  }

  /**
   * This is used to redirect the app with props
  */
  const goPayment = async () => {
    history.push({pathname: '/payment', state: { template, currentService } }) 
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <DialogContent>
        <DialogContentText style={{whiteSpace: 'pre-line'}}>
          { `\n
            ¡Has finalizado tu documento con éxito!  \n
            Para descargar el documento te invitamos a realizar el pago. Haz clic en el botón ´Pagar´ o ingresa a la sección ´Mis Solicitudes´, selecciónalo y realiza el pago. \n`
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={goDocuments} color="primary">
          Ir a mis solicitudes
        </Button>
        {template && template.price !== 0 && currentService && currentService.service_status_id !== SERVICE_STATUS.PAID && (
          <>
            <Button onClick={goPayment} color="primary">
              Pagar
            </Button>
          </>
        )}        
      </DialogActions>
    </Dialog>
  )
}

export default EndServiceDialog